import { render, staticRenderFns } from "./lhcForm.vue?vue&type=template&id=90b168d4&scoped=true&"
import script from "./lhcForm.vue?vue&type=script&lang=js&"
export * from "./lhcForm.vue?vue&type=script&lang=js&"
import style0 from "./lhcForm.vue?vue&type=style&index=0&id=90b168d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b168d4",
  null
  
)

export default component.exports